<template>
	<div class="scroll">
		<div class="scroll_inside">
			<div id="ggicon" class="el-icon-thirdicon-gonggao2">	</div>
			<ul class="list-unstyled">
				<router-link tag='li' v-for='item in items' key="in" style="text-decoration: none;color:white;" :to="{path:'/noticePage', query:{uuid:item.vc_contentcode}}">
			    {{item.vc_title}}
			    </router-link>
			</ul>
			<div id="moremes">
				<router-link tag='span' to='/announcementPage'>更多...</router-link>
			</div>
		</div>
	</div>
</template>
<script>
	import '@/router/jquery-3.3.1.min.js'
	export default {
		data() {
			return {
				items:''
			}
			//默认数据
		},
		methods: {
			
			hover() {
			let that = this;
			var timer = setInterval(that.auto,5000);
			$(".scroll").hover(function() {
				//清除滚动
				clearInterval(timer);
			},function() {
				//重新滚动
					 timer = setInterval(that.auto, 5000);
			})
			},
			auto() { //top的位移高度尽量和scroll的高度相同，可以很好控制滚动范围
				$(".scroll ul").animate({
					"top": "-100%"
				}, 1000, function() {
					//将ul的第一个li加到ul的最后
					$(".scroll ul").css("top", "0px").find("li:first").appendTo(".scroll .scroll_inside>ul");
				})
			}
		},
	}
</script>
<style type="text/css">
	.scroll {
		position: absolute;
		width: 100%;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		cursor: pointer;
		overflow: hidden;
		z-index: 10;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		background: rgba(0,0,0,.5);
	}
	.scroll .scroll_inside{
		width: 1200px;
		margin: 0 auto;
		position: relative;
		line-height: 40px;
		list-style-type: none;
		height: 40px;
	}
	.scroll ul {
		width: 1000px;
		position: relative;
		line-height: 40px;
		/*list-style-type: none;*/
		height: 40px;
		left: 60px;
		top: 0;
	}
	.scroll ul li{
		list-style: none;
		width: 1000Px;
		text-align: left;
		height: 40px;
		line-height: 40px;
		color: white;
	}
	#ggicon{
		width: 60px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		position: absolute;
		font-size: 20px;
		color: white;
		left: 0;
		top: 0;
	}
	#moremes{
		width: 80px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		position: absolute;
		font-size: 16px;
		color: #076BF2;
		right: 0;
		top: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/rolling.vue